import {useState} from "react";
import WalletPasswordInput from "../components/WalletPasswordInput";
import {createPromise} from "../utils/createPromise";
import {PasswordInputType} from "../common/types/components";

export const usePasswordInput = () => {
    const [showInput, setShowInput] = useState(false);
    const [resolver, setResolver] = useState<any>({resolve: null});
    const [type, setType] = useState<PasswordInputType>(PasswordInputType.REGISTER);
    const [failedLoginAttempts, setFailedLoginAttempts] = useState(0);

    const onComplete = (value: string) => {
        resolver.resolve(value);
        setShowInput(false);
    }

    const getPassword = async (type: PasswordInputType, failedAttempts: number = 0) => {
        setType(type);
        setFailedLoginAttempts(failedAttempts);
        const [promise, resolve] = createPromise<string>()
        setResolver({resolve})
        setShowInput(true);
        return promise;
    };

    const PasswordInput = () => {
        return <WalletPasswordInput
            open={showInput}
            onComplete={onComplete}
            type={type}
            failedAttempts={failedLoginAttempts}
        />
    }

    return {
        getPassword,
        PasswordInput,
        visible: showInput
    }
}